export default __webpack_public_path__ + "static/media/iranyekanwebbold.b163d295.woff";